const TheSoundOfSilence = [
	'[Verse 1]',
	'Hello darkness, my old friend,',
	"I've come to talk with you again,",
	'Because a vision softly creeping,',
	'Left its seeds while I was sleeping,',
	'And the vision that was planted in my brain',
	'Still remains',
	'Within the sound of silence.',
	'',
	'[Verse 2]',
	'In restless dreams I walked alone',
	'Narrow streets of cobblestone,',
	"'neath the halo of a street lamp,",
	'I turned my collar to the cold and damp',
	'When my eyes were stabbed by the flash of a neon light',
	'That split the night',
	'And touched the sound of silence.',
	'',
	'[Verse 3]',
	'And in the naked light I saw',
	'Ten thousand people, maybe more.',
	'People talking without speaking,',
	'People hearing without listening,',
	'People writing songs that voices never share',
	'And no one dare',
	'Disturb the sound of silence.',
	'',
	'[Verse 4]',
	'Fools said I, you do not know',
	'Silence like a cancer grows.',
	'Hear my words that I might teach you,',
	'Take my arms that I might reach you.',
	'But my words like silent raindrops fell,',
	'',
	'And echoed',
	'In the wells of silence',
	'',
	'[Verse 5]',
	'And the people bowed and prayed',
	'To the neon God they made.',
	'And the sign flashed out its warning,',
	'In the words that it was forming.',
	'And the sign said, the words of the prophets',
	'',
	'[Outro]',
	'Are written on the subway walls',
	'And tenement halls.',
	"And whisper'd in the sounds of silence.",
];

export default TheSoundOfSilence;
